import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppForbiddenComponent, AppNotFoundComponent, AppServerErrorComponent } from '@app/base/errors';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AppForbiddenComponent, AppNotFoundComponent, AppServerErrorComponent],
  exports: [
    AppNotFoundComponent,
    AppForbiddenComponent,
    AppServerErrorComponent
  ]
})
export class ErrorsModule { }
